import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to, from) => {
  const nuxtApp = useNuxtApp()

  // Zachytíme chyby v middleware
  nuxtApp.hook('app:error', (error: unknown) => {
    console.error('Middleware error caught:', error)

    // Zachytíme TypeError: Failed to fetch
    if (error instanceof TypeError && error.message === 'Failed to fetch') {
      console.error('Network error detected in middleware:', error)
      nuxtApp.vueApp.provide('showError500', true)
      return
    }

    // Zachytíme Supabase auth chyby
    if (error && typeof error === 'object' && 'message' in error) {
      const err = error as { message: string }
      if (err.message.includes('invalid_grant') || err.message.includes('JWT expired')) {
        console.error('Auth error detected in middleware:', err)
        nuxtApp.vueApp.provide('showError500', true)
        return
      }
    }

    // Zachytíme Response chyby
    if (error instanceof Response) {
      console.error('Response error in middleware:', error.status, error.statusText)
      if (error.status === 500 || error.status === 401) {
        nuxtApp.vueApp.provide('showError500', true)
        return
      }
    }
  })
})
